import "src/pages/home/components/RoomCard/RoomCardXS/sections/shared/Wrapper/Wrapper.css"
import "src/pages/home/components/RoomCard/RoomCardXS/RoomCardXS.css"
import SkeletonItem from "./SkeletonItem"

function SkeletonCardXL() {
    return (
        <div className="room-card--xs__container">
            <div className="room-card--xs__wrapper" style={{ backgroundColor: "var(--white)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <SkeletonItem width={40} height={40} borderRadius="50%" />
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end", flex: 1, marginLeft: 8 }}>
                        <SkeletonItem width="40%" height={14} borderRadius={6} />
                        <SkeletonItem width="25%" height={24} borderRadius={6} />
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                    <SkeletonItem width="40%" height={24} borderRadius={6} />
                    <SkeletonItem width="50%" height={14} borderRadius={6} />
                </div>
                <SkeletonItem width="100%" height={40} borderRadius={6} />
            </div>
        </div>
    )
}

export default SkeletonCardXL
